export const actions = Object.freeze({
    contactus: 'contactus',
    init:'init'
});
